// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixed-button[data-v-6617e206]{position:sticky;bottom:40px;right:20px;z-index:9999;justify-content:flex-end;display:flex;pointer-events:none}.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg[data-v-6617e206]{background-color:rgba(0,0,0,.12)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
